import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
const goodFit = ['The book is already in the world', 'The book supports a real business, not just a royalty stream', 'You have a method, framework, point of view, or body of work', 'The book points toward coaching, consulting, speaking, training, workshops, courses, certification, advisory, events, community, or team implementation', 'You want the book to keep creating movement after launch'];
const notFit = ['You only want to sell more books', 'You want bestseller, PR, ads, publishing, or ghostwriting help', 'You want a cheap author website', 'You have no downstream offer', 'You want a generic funnel'];
export function FitInvestment() {
  const {
    openDiagnostic
  } = useScore();
  return <SectionBand tone="paper" width="wide" data-id="element-706" data-mp="2rdassa0gqfuw">
      <div className="max-w-3xl" data-id="element-707" data-mp="2w99flt657pt7">
        <Reveal data-id="element-708" data-mp="2waaz8m185kmj">
          <Eyebrow data-id="element-709" data-mp="2wbvtsbnjh3ke">Fit &amp; investment</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-710" data-mp="126jbc70rihzl">
            Built for expert books with
            <br data-id="element-711" data-mp="xdghryvzj8je" />
            <span className="italic text-seaglass" data-id="element-712" data-mp="xcy9u4zyn5vn">real work behind them.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-713" data-mp="ngvb794bhpdg">
        <Reveal delay={0.1} data-id="element-714" data-mp="niepwvabrsd4">
          <div className="h-full rounded-3xl border border-seaglass/40 bg-white p-8 shadow-[0_16px_36px_-24px_rgba(139,168,159,0.7)] md:p-9" data-id="element-715" data-mp="1l4c1s9u78zg3">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-seaglass" data-id="element-716" data-mp="1g6kddpsrjvgn">
              Good fit
            </p>
            <ul className="mt-6 space-y-4" data-id="element-717" data-mp="1b894bhaalozh">
              {goodFit.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-718" data-mp="173jadxz72kh7">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-seaglass text-xs font-bold text-white" data-id="element-719" data-mp="3vwwswileshpv">
                    ✓
                  </span>
                  <span className="leading-relaxed text-text" data-id="element-720" data-mp="3tbfmqfizzrkb">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.15} data-id="element-721" data-mp="255uw3zsh8i7">
          <div className="h-full rounded-3xl border border-gray-200 bg-paper-dark p-8 md:p-9" data-id="element-722" data-mp="23bije2l2opq">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted" data-id="element-723" data-mp="3jg5irm91ha3w">
              Not a fit
            </p>
            <ul className="mt-6 space-y-4" data-id="element-724" data-mp="3akxzgqgxpo6c">
              {notFit.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-725" data-mp="3ajmreegghu9f">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-xs font-bold text-gray-500" data-id="element-726" data-mp="3fdqz4zxjq6bk">
                    ✕
                  </span>
                  <span className="leading-relaxed text-text-muted" data-id="element-727" data-mp="35mwgs6nf7qve">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>

      {/* Investment */}
      <Reveal delay={0.15} data-id="element-728" data-mp="2vmx6o5bcrsgf">
        <div className="mt-10 overflow-hidden rounded-[2rem] bg-navy px-8 py-16 text-center text-paper md:px-16 md:py-20" data-id="element-729" data-mp="2vqb6b5smtnk6">
          <div className="mx-auto max-w-2xl" data-id="element-730" data-mp="28139ezdd5pyx">
            <p className="text-sm uppercase tracking-[0.22em] text-gray-400" data-id="element-731" data-mp="2824ulwo3fsud">
              Reader-to-Revenue Builds start at
            </p>
            <div className="mt-6 font-serif text-6xl font-semibold leading-none tracking-[-0.02em] text-sand md:text-8xl" data-id="element-732" data-mp="2h1hx25dsvh5l">
              $12,500
            </div>
            <div className="mx-auto mt-10 max-w-xl space-y-4 text-lg leading-relaxed text-gray-300" data-id="element-733" data-mp="2vx7o4hxuekh6">
              <p data-id="element-734" data-mp="2qz61jn17k30y">
                Not a low-ticket funnel, a prettier author website, or a pile of
                bonus resources.
              </p>
              <p className="text-paper" data-id="element-735" data-mp="30pqwn0hoapf4">
                One done-for-you system built behind the authority the book
                already created.
              </p>
              <p data-id="element-736" data-mp="3en5qqiivfldf">
                The economics tend to make sense when one or two right-fit
                opportunities — advisory, consulting, a workshop, a cohort, a
                speaking engagement, certification, or team implementation —
                could justify it.
              </p>
            </div>
            <div className="mt-12 flex justify-center" data-id="element-737" data-mp="6f7ji7acq7u8">
              <Cta variant="primary" showArrow onClick={openDiagnostic} className="px-10 py-4 text-lg" data-id="element-738" data-mp="6fr3dtjkb6aw">
                Get Your Reader-to-Revenue Score
              </Cta>
            </div>
          </div>
        </div>
      </Reveal>
    </SectionBand>;
}